import JSZip from 'jszip';
import defined from '~app/core/defined';
import Logging from '~app/core/logging';
import makeCSV from '~app/core/makeCSV';

const log = Logging.getLogger('app.core.zip');

const stateFileName = '__project.json';
const compressionLevel = 5;

function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
  else
      byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], {type:mimeString});
}

function blobToDataURI(blob) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = (e) => {
      resolve(e.target.result);
      log.debug('File loaded');
    };
    reader.onerror = (e) => {
      reject(e.error);
    };
    reader.readAsDataURL(blob);
  });
}

function loadFileDataURI(zip, fileName){
  return zip.files[fileName].async('blob')
    .then(blob => {
      return blobToDataURI(blob);
    });
}

export function stateToZip(blob = false) {
  return async (dispatch, getState) => {
    var state = getState();
    let nodes = state.nodeList.present.nodes;
    let header = state.nodeList.present.header;
    let version = state.app.version || "standard";
    let zip =  new JSZip();

    // export a csv containing data about project
    const csv = makeCSV(nodes);
    zip.file('project.csv', csv);

    // Add images and attachments to zip
    nodes.forEach(node => {
      // Iterate over images
      node.images.forEach(image => {
        if(defined(image)){
          let blob = dataURItoBlob(image.data);
          zip.file(image.fileName, blob);
        }
      });
      // Iterate over attachments
      node.attachments.forEach(attachment => {
        let blob = dataURItoBlob(attachment.data);
        zip.file(attachment.fileName, blob);
      });
    });
    let saveState = { nodes, header, version };
    let filedata = JSON.stringify(saveState);
    zip.file(stateFileName, filedata);
    zip.file("Readme.txt", "This zip file is meant to be opened by the application, How Science Works. Visit https://www.hhmi.org/biointeractive/how-science-works \n");

    // googleDrive uses the compressed format
    // for downloading to the local file system,
    // filesaver.js expects a regular blob
    const zipFormat = blob ?
      { type: 'blob' } :
      {
        type:'base64',
        compression: 'DEFLATE',
        level: compressionLevel,
      };

    // generate zip file and return to caller
    let fileData = await zip.generateAsync(zipFormat);
    return fileData;
  };
}

export function zipToState(zipData, isBase64=false) {
  return (dispatch) => {
    return new Promise((resolve, reject)=> {
      var zip, savedState;
      JSZip.loadAsync(zipData, {base64:isBase64})
      .then(res => {
        zip = res;
        return zip.files[stateFileName].async('string');
      })
      .then(savedStateData => {
        // Load the JSON file
        savedState = JSON.parse(savedStateData);
        log.debug('Nodes parsed');

        // Iterate over nodes
        let nodes = savedState.nodes;
        // let header = savedState.header;
        let promises = [];
        nodes.map(node => {
          // Iterate over images
          node.images.map(image => {
            if(defined(image) && defined(image.fileName)){
              // Load the image file data
              let p = loadFileDataURI(zip, image.fileName)
              .then(data => {
                log.debug('Data loaded');
                image.data = data;
              });
              promises.push(p);
            }
            return image;
          });
          // Iterate over attachments
          node.attachments.map(attachment => {
            log.debug(attachment.fileName);
            // Load the file attachment data
            let p = loadFileDataURI(zip, attachment.fileName)
            .then(data => {
              log.debug('Data loaded');
              attachment.data = data;
            });
            promises.push(p);
            return attachment;
          });
          return node;
        });
        return Promise.all(promises).then(()=>{
          log.debug('All promises resolved');
        });
      })
      .then(()=>{
        log.debug('Returning nodes');
        resolve (savedState);
      })
      .catch(e=>{
        log.error(e.error);
        reject(e.error);
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/core/zip.js